import { Document, Page, View, StyleSheet, Text, Image, Font } from "@react-pdf/renderer";
import imgKkp from '../../../assets/images/logo_kkp.jpg'
import srcArial from '../../../assets/custom/font/arial/arial.ttf'
import srcArialBold from '../../../assets/custom/font/arial/ARIBL0.ttf'
import { useCallback, useEffect, useMemo, useState } from "react";
import KapalService from "../../../services/kapal/KapalService";
import UserService from "../../../services/user/UserService";
import { formatDateStringLocalDateINA, formatTanggalNarasiINA, getNamaUPTBaru } from "../../../utilities/Utils";
import PelabuhanPendaratan from "../../../utilities/kapal/PelabuhanPendaratan";

// Register fonts
Font.register({ family: 'Arial', src: srcArial });
Font.register({ family: 'Arial-Bold', src: srcArialBold });

// Styles
const styles = StyleSheet.create({
  page: {
    paddingTop: 20,
    paddingBottom: 48,
    paddingHorizontal: 42,
    boxSizing: "border-box"
  },
  headingImg: {
    width: 115,
    height: 100,
  },
  table: {
    display: "table",
    width: "auto"
  },
  tableRow: {
    flexDirection: "row",
    flexWrap: "wrap"
  },
  tableCol: {
    borderWidth: 0,
    padding: 1
  },
  text: {
    fontSize: 10,
    fontFamily: "Arial"
  },
  textcenter: {
    fontSize: 10,
    fontFamily: "Arial",
    textAlign: "center"
  },
  textBold: {
    fontSize: 10,
    fontFamily: "Arial-Bold"
  },
  cell: {
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderColor: '#000',
    padding: 4,
    minHeight: 24,
    textAlign: 'center',
    justifyContent: 'center',
  }
});

// Komponen PDF
const CetakSTKapal = ({ dataDisposisi, dataPpmKapal }) => {
  const currentDate = new Date()
  // const currentMonth = currentDate.getMonth() + 1
  const currentYear = currentDate.getFullYear()

  let kapalService = useMemo(() => new KapalService(), [])
  let userService = useMemo(() => new UserService(), [])

  const [valuePejabatOpt, setValuePejabatOpt] = useState(null)
  const [valuePegawaiOpt, setValuePegawaiOpt] = useState(null)
  const [uptData, setUptData] = useState(null)

  const fetchAllData = useCallback(async () => {
    if (!dataPpmKapal?.nomorAjuKapal || !dataDisposisi?.noTugas) {
      console.log("data Kapal atau data disposisi kosong")
      return
    }

    try {
      const results = await Promise.allSettled([
        userService.getPegawaiById(dataDisposisi.nipPejabat),
        kapalService.listPenugasanDetilAll(dataDisposisi.idProses),
        userService.getUptById(dataPpmKapal.kodeUpt)
      ])

      const [resPejabat, resPegawai, resUpt] = results

      const getData = (res, fallback = []) =>
        res.status === "fulfilled"
          ? res.value?.data?.data ?? res.value?.data ?? fallback
          : fallback;

      setValuePejabatOpt(getData(resPejabat))
      setValuePegawaiOpt(getData(resPegawai))
      setUptData(getData(resUpt))

    } catch (error) {
      console.log(error)
    }

  }, [dataDisposisi, dataPpmKapal, kapalService, userService])

  useEffect(() => {
    let isMounted = true;
    if (!dataPpmKapal) return;

    const loadData = async () => {
      try {
        await fetchAllData();
      } catch (e) {
        if (isMounted) console.error(e);
      }
    };

    loadData();

    return () => { isMounted = false; };
  }, [dataPpmKapal, fetchAllData]);

  return (
    <Document>
      <Page size="A4" style={styles.page} fixed>
        {/* HEADER */}
        <View style={[styles.table, { marginBottom: 3 }]}>
          <View style={[styles.tableRow, { borderBottom: 2, borderBottomStyle: 'solid' }]}>
            <View style={[styles.tableCol, { width: '25%' }]}>
              <Image style={styles.headingImg} src={imgKkp} />
            </View>
            <View style={[styles.tableCol, { width: '70%', alignItems: 'center' }]}>
              <Text style={[styles.textBold, { fontSize: 14, textAlign: 'center', color: '#0000ff' }]}>KEMENTERIAN KELAUTAN DAN PERIKANAN</Text>
              <Text style={[styles, { fontSize: 16, textAlign: 'center', color: '#0000ff' }]}>BADAN PENGENDALIAN DAN PENGAWASAN</Text>
              <Text style={[styles, { fontSize: 16, textAlign: 'center', color: '#0000ff' }]}>MUTU HASIL KELAUTAN DAN PERIKANAN</Text>
              <Text style={[styles.textBold, { fontSize: 14, textAlign: 'center', color: '#0000ff' }]}>{uptData && dataDisposisi && getNamaUPTBaru(dataDisposisi.tglTugas, uptData)}</Text>
              <Text style={[styles.text, { textAlign: 'center' }]}>{uptData && uptData.alamatUnit}</Text>
            </View>
          </View>
        </View>

        {/* JUDUL */}
        <View style={[styles.table, { marginBottom: 5 }]}>
          <View style={styles.tableRow}>
            <View style={[styles.tableCol, { width: '100%', alignItems: 'center' }]}>
              <Text style={[styles.text, { fontSize: 12 }]}>SURAT TUGAS</Text>
            </View>
          </View>
          <View style={styles.tableRow}>
            <View style={[styles.tableCol, { width: '100%', alignItems: 'center' }]}>
              <Text style={[styles.text, { fontSize: 12 }]}>Nomor: {dataDisposisi && dataDisposisi.noTugas}</Text>
            </View>
          </View>
        </View>

        {/* ISI */}
        <View style={[styles.table, { marginBottom: 5 }]}></View>
        <View style={styles.table}>
          <View style={[styles.tableRow, { marginBottom: 10 }]}>
            <View style={[styles.tableCol, { width: '20%' }]}>
              <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Menimbang</Text>
            </View>
            <View style={[styles.tableCol, { width: '3%' }]}>
              <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>:</Text>
            </View>
            <View style={[styles.tableCol, { width: '3%' }]}>
              <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
            </View>
            <View style={[styles.tableCol, { width: '74%' }]}>
              <Text style={[styles.text, { fontSize: 12, textAlign: 'justify' }]}>bahwa dalam rangka penerapan Sistem Jaminan Mutu dan Keamanan Hasil Kelautan dan Perikanan yang tertuang dalam Peraturan Menteri Kelautan dan Perikanan Nomor 10 Tahun 2024 tentang Cara Penanganan Ikan yang Baik, perlu dilakukan kegiatan inspeksi dalam rangka penilaian kesesuaian persyaratan SJMKHP</Text>
            </View>
            <View style={[styles.tableCol, { width: '20%' }]}>
              <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Dasar</Text>
            </View>
            <View style={[styles.tableCol, { width: '3%' }]}>
              <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>:</Text>
            </View>
            <View style={[styles.tableCol, { width: '3%' }]}>
              <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
            </View>
            <View style={[styles.tableCol, { width: '74%' }]}>
              <Text style={[styles.text, { fontSize: 12, textAlign: 'justify' }]}>Daftar Isian Pelaksanaan Anggaran Satker {uptData && dataDisposisi && getNamaUPTBaru(dataDisposisi.tglTugas, uptData)} Tahun Anggaran {currentYear}. Segala biaya yang timbul berkaitan dengan pelaksanaan tugas dibebankan pada Anggaran Satker {uptData && dataDisposisi && getNamaUPTBaru(dataDisposisi.tglTugas, uptData)}</Text>
            </View>
          </View>
        </View>

        <View style={[styles.table, { marginBottom: 5 }]}>
          <View style={styles.tableRow}>
            <View style={[styles.tableCol, { width: '100%', alignItems: 'center' }]}>
              <Text style={[styles.text, { fontSize: 12 }]}>Memberi Tugas</Text>
            </View>
          </View>
        </View>
        <View style={styles.table}>
          <View style={[styles.tableRow, { marginBottom: 10 }]}>
            <View style={[styles.tableCol, { width: '20%' }]}>
              <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Kepada</Text>
            </View>
            <View style={[styles.tableCol, { width: '3%' }]}>
              <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>:</Text>
            </View>
            {
              valuePegawaiOpt && valuePegawaiOpt.map((pegawai, index) => (
                <>
                  <View style={[styles.tableCol, { width: '3%' }]}>
                    <Text style={[styles.text, { fontSize: 11, textAlign: 'left' }]}>{index + 1}.</Text>
                  </View>
                  <View style={[styles.tableCol, { width: '74%' }]}>
                    <Text style={[styles.text, { fontSize: 11, textAlign: 'left' }]}>{pegawai.nmPetugas}/ {pegawai.nipPetugas}</Text>
                  </View>
                  <View style={[styles.tableCol, { width: '20%' }]}>
                    <Text style={[styles.text, { fontSize: 11, textAlign: 'left' }]}></Text>
                  </View>
                  <View style={[styles.tableCol, { width: '3%' }]}>
                    <Text style={[styles.text, { fontSize: 11, textAlign: 'left' }]}></Text>
                  </View>
                </>
              ))
            }
          </View>
        </View>


        <View style={[styles.table, { marginBottom: 5 }]}></View>
        <View style={styles.table}>
          <View style={[styles.tableRow, { marginBottom: 10 }]}>
            <View style={[styles.tableCol, { width: '20%' }]}>
              <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Untuk</Text>
            </View>
            <View style={[styles.tableCol, { width: '3%' }]}>
              <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>:</Text>
            </View>
            <View style={[styles.tableCol, { width: '3%' }]}>
              <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>a.</Text>
            </View>
            <View style={[styles.tableCol, { width: '74%' }]}>
              <Text style={[styles.text, { fontSize: 12, textAlign: 'justify' }]}>Melaksanakan inspeksi penerapan CPIB kapal {dataPpmKapal && dataPpmKapal.namaKapal} di {dataPpmKapal && <PelabuhanPendaratan id={dataPpmKapal.tempatPendaratan}/>} pada {formatTanggalNarasiINA(dataDisposisi.tglTugas)};</Text>
            </View>
            <View style={[styles.tableCol, { width: '20%' }]}>
              <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
            </View>
            <View style={[styles.tableCol, { width: '3%' }]}>
              <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
            </View>
            <View style={[styles.tableCol, { width: '3%' }]}>
              <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>b.</Text>
            </View>
            <View style={[styles.tableCol, { width: '74%' }]}>
              <Text style={[styles.text, { fontSize: 12, textAlign: 'justify' }]}>Membuat laporan tertulis pelaksanaan tugas hasil inspeksi dan melaporkannya kepada Kepala Satker {uptData && dataDisposisi && getNamaUPTBaru(dataDisposisi.tglTugas, uptData)};</Text>
            </View>
            <View style={[styles.tableCol, { width: '20%' }]}>
              <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
            </View>
            <View style={[styles.tableCol, { width: '3%' }]}>
              <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
            </View>
            <View style={[styles.tableCol, { width: '3%' }]}>
              <Text style={[styles.textBold, { fontSize: 11, textAlign: 'left' }]}>c.</Text>
            </View>
            <View style={[styles.tableCol, { width: '74%' }]}>
              <Text style={[styles.textBold, { fontSize: 11, textAlign: 'justify' }]}>Apabila pada saat inspeksi terdapat kapal perikanan yang tidak ada kegiatan pembongkaran, maka inspeksi dibatalkan;</Text>
            </View>
            <View style={[styles.tableCol, { width: '20%' }]}>
              <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
            </View>
            <View style={[styles.tableCol, { width: '3%' }]}>
              <Text style={[styles.textBold, { fontSize: 12, textAlign: 'left' }]}></Text>
            </View>
            <View style={[styles.tableCol, { width: '3%' }]}>
              <Text style={[styles.textBold, { fontSize: 11, fontWeight: 'bold', textAlign: 'left' }]}>d.</Text>
            </View>
            <View style={[styles.tableCol, { width: '74%' }]}>
              <Text style={[styles.textBold, { fontSize: 11, textAlign: 'justify' }]}>Inspektur Mutu tidak diperkenankan menerima sesuatu dari pelaku usaha yang akan berpengaruh terhadap hasil inspeksi.</Text>
            </View>
          </View>
        </View>
        <View style={styles.table}>
          <View style={[styles.tableRow, { marginBottom: 10 }]}>
            <View style={[styles.tableCol, { width: '100%' }]}>
              <Text style={[styles.text, { fontSize: 12, textAlign: 'justify' }]}>Demikian Surat Tugas ini dibuat, untuk dilaksanakan dengan sebaik-baiknya dan penuh tanggung jawab.</Text>
            </View>
          </View>
        </View>

        <View style={styles.table}>
          <View style={[styles.tableRow]}>
            <View style={[styles.tableCol, { width: '20%' }]}>
              <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
            </View>
            <View style={[styles.tableCol, { width: '3%' }]}>
              <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
            </View>
            <View style={[styles.tableCol, { width: '33%' }]}>
              <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
            </View>
            <View style={[styles.tableCol, { width: '44%' }]}>
              <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>{uptData && uptData.kota}, {dataDisposisi && formatDateStringLocalDateINA(dataDisposisi.tglTugas)}</Text>
            </View>
            <View style={[styles.tableCol, { width: '20%' }]}>
              <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
            </View>
            <View style={[styles.tableCol, { width: '3%' }]}>
              <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
            </View>
            <View style={[styles.tableCol, { width: '33%' }]}>
              <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
            </View>
            <View style={[styles.tableCol, { width: '44%' }]}>
              <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Kepala UPT</Text>
            </View>
            <View style={[styles.tableCol, { width: '56%' }]}>
              <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
            </View>
            <View style={[styles.tableCol, { width: '44%' }]}>
              <Text style={[styles.text, { fontSize: 12, textAlign: 'left', marginTop: 50 }]}>{valuePejabatOpt && valuePejabatOpt.nama}</Text>
            </View>
          </View>
        </View>

        <View style={styles.table}>
          <View style={[styles.tableRow, { marginTop: 5 }]}>
            <View style={[styles.tableCol, { width: '100%' }]}>
              <Text style={[styles.text, { fontSize: 12 }]}>Tembusan</Text>
            </View>
            <View style={[styles.tableCol, { width: '100%' }]}>
              <Text style={[styles.text, { fontSize: 12 }]}>1. Kepala BPPMHKP;</Text>
            </View>
            <View style={[styles.tableCol, { width: '100%' }]}>
              <Text style={[styles.text, { fontSize: 12 }]}>2.	Kepala Pusat Pengendalian dan Pengawasan Mutu Produksi Primer.</Text>
            </View>
          </View>
        </View>
      </Page>

      {/* <Page size="A4" style={styles.page} fixed> */}
        {/* <View style={[styles.tableRow, { marginTop: 40 }]}> */}
          {/* Judul */}
          {/* <Text style={[styles.text, { fontSize: 12 }]}>
            Lampiran: Daftar Kapal Perikanan yang Diinspeksi
          </Text> */}

          {/* Header Tabel */}
          {/* <View style={{ flexDirection: 'row', marginTop: 10 }}>
            <View style={[styles.cell, { width: '10%', borderTopWidth: 1, borderLeftWidth: 1 }]}>
              <Text style={[styles.textBold, { fontSize: 10 }]}>No</Text>
            </View>
            <View style={[styles.cell, { width: '30%', borderTopWidth: 1 }]}>
              <Text style={[styles.textBold, { fontSize: 10 }]}>Nama Kapal Perikanan</Text>
            </View>
            <View style={[styles.cell, { width: '40%', borderTopWidth: 1 }]}>
              <Text style={[styles.textBold, { fontSize: 10 }]}>
                Jenis Kapal (Kapal penangkap / pengangkut / pembeku)
              </Text>
            </View>
            <View style={[styles.cell, { width: '20%', borderTopWidth: 1, borderRightWidth: 1 }]}>
              <Text style={[styles.textBold, { fontSize: 10 }]}>Ukuran Kapal (GT)</Text>
            </View>
          </View> */}
          {/* Baris Data */}
          {/* {barisTampilan.map((kapal, index) => (
            <View key={index} style={{ flexDirection: 'row' }}>
              <View style={[styles.cell, { width: '10%', borderLeft: 1 }]}>
                <Text style={styles.text}>{kapal.no}</Text>
              </View>
              <View style={[styles.cell, { width: '30%' }]}>
                <Text style={styles.text}>{kapal.nama}</Text>
              </View>
              <View style={[styles.cell, { width: '40%' }]}>
                <Text style={styles.text}>{kapal.jenis}</Text>
              </View>
              <View style={[styles.cell, { width: '20%' }]}>
                <Text style={styles.text}>{kapal.ukuran}</Text>
              </View>
            </View>
          ))} */}


        {/* </View> */}

      {/* </Page> */}
    </Document>
  )
}

export default CetakSTKapal;
